import React from "react";
import "./SeparatorBar.css";

const SeparatorBar = () => {
  return <div className="separator-bar"></div>;
};

export default SeparatorBar;
